import { PurchaseOrderDto } from './purchaseOrder.dto';
import { BaseDto } from './base.dto';

export class PurchaseOrderStatusDto extends BaseDto {
    purchaseOrderStatus: string;
    purchaseOrderStatusId: number;
    purchaseOrder: PurchaseOrderDto[];
}